module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/admin/icontact/setting/expert/organization/organization.component.css
// module id = ./src/app/pages/admin/icontact/setting/expert/organization/organization.component.css
// module chunks = main